import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { CONTEXT } from './constants';
import { JsonLdContext } from './JsonLdContext';
export var JsonLd = function JsonLd(_ref) {
  var type = _ref.type,
      children = _ref.children;

  var _React$useContext = React.useContext(JsonLdContext),
      addToSchemaType = _React$useContext.addToSchemaType;

  var jsonLd = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, CONTEXT), children);
  }, [children]);
  React.useMemo(function () {
    if (type) {
      addToSchemaType === null || addToSchemaType === void 0 ? void 0 : addToSchemaType(type, children);
    }
  }, [addToSchemaType, children, type]);

  if (type) {
    return null;
  }

  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(jsonLd)
    }
  });
};